import { useIntl } from "react-intl";
import {
  IntegrationTypeCategory,
  useIntegrationTypes,
} from "../hooks/useIntegrationTypes";
import {
  IntegrationTypeCardsModal,
  IntegrationTypeSelector,
} from "./IntegrationModal";
import ModalFullPage from "./ModalFullPage";

interface AddIntegrationTypeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectType: (typeName: string) => void;
  category?: IntegrationTypeCategory;
}

function isIspmHost(): boolean {
  return (
    typeof window !== "undefined" &&
    (window as Window & { __MFE_HOST__?: string }).__MFE_HOST__ === "ispm"
  );
}

/**
 * Modal shown at /intelligence/integrations when user clicks "Add Integration".
 *
 * Under the ispm host, renders a ModalIsland with a redesigned card grid.
 * Under the legacy (ui-track) host or standalone dev, keeps the existing
 * full-page modal + IntegrationTypeSelector.
 */
export function AddIntegrationTypeModal({
  isOpen,
  onClose,
  onSelectType,
  category,
}: AddIntegrationTypeModalProps) {
  const intl = useIntl();
  const ispmHost = isIspmHost();

  const {
    data: integrationTypes,
    isLoading,
    error,
  } = useIntegrationTypes({
    enabled: isOpen && !ispmHost,
    category,
  });

  if (ispmHost) {
    return (
      <IntegrationTypeCardsModal
        isOpen={isOpen}
        onClose={onClose}
        onSelectType={onSelectType}
        category={category}
      />
    );
  }

  return (
    <ModalFullPage
      isOpen={isOpen}
      onClose={onClose}
      closeOnEsc
      title={intl.formatMessage({
        id: "YYujKG",
        defaultMessage: "Add Integration",
        description: "Page title for add integration form",
      })}
    >
      <IntegrationTypeSelector
        integrationTypes={integrationTypes || []}
        isLoading={isLoading}
        error={error}
        onSelect={onSelectType}
      />
    </ModalFullPage>
  );
}
